
import { Injectable } from '@angular/core';
import { Body } from '../../model/Body';
import { MessageService } from '../service-ui/message.service';
import { HttpClient } from '@angular/common/http';
import { StartupService } from '../service-ui/startup.service';
import {AbstractLiveDataService} from "./abstract-live-data.service";
import {NotificationsService} from "./notifications.service";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class BodyService extends AbstractLiveDataService<Body> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    this.notificationsService.setBodyService(this);
    this.notificationsService.startNotification();
  }

  makeObjectInstance(args: any): Body {
    return new Body(args);
  }

  getLoggingObjectTypeName (): string {
    return "Body";
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint (): string {
    return "body";
  }

  getLinkData(): any[] {
    return [
      { action: 'Link', objectIdPropertyName: 'resource_ID', serviceName: 'resourceService', arrayProperty: 'bodys', objectProperty: 'resource'},
    ];
  }

  getStandardizedURL (resourceId: number, filename: string): Observable<string> {
    const url = `${environment.apiBaseURL}${this.getURLEndPoint()}/standardizedURL/${resourceId}/${filename}`;
    return this.http.get(url, this.startupService.getHttpOptions())
      .pipe(
        map(image => {
          return image;
        }),
        catchError(this.handleErrorT<any>('getPreparedURL'))
      );
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleErrorT<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.loadingState = 'INITIAL';

      // TODO: send the error to remote logging infrastructure
      console.error(error, operation); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
